import contentful, {
  flattenEntryResponse,
  flattenEntryResponseSingle,
} from '@aletheia/common/lib/contentful'

import { IPartner } from '../types/generated'

/**
 * Fetch a single Partner from Contenful
 *
 * @param {string} slug The slug of this partner organization
 */
export const fetchPartner = async (
  slug: string,
): Promise<IPartner | undefined> => {
  return flattenEntryResponseSingle(
    await contentful.getEntries({
      content_type: 'partner',
      'fields.slug': slug,
      include: 5,
    }),
  ) as IPartner | undefined
}

/**
 * Fetch all Partners from Contentful
 *
 * @param {object} query Options to pass to contentful.getEntries()
 */
export const fetchPartners = async (
  query?: Record<string, unknown>,
): Promise<IPartner[]> => {
  return flattenEntryResponse(
    await contentful.getEntries({
      include: 5,
      ...query,
      content_type: 'partner',
    }),
  ) as IPartner[]
}
